"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnRankProperty = exports.resultsTableColumnRankPropertyDefinition = void 0;
exports.resultsTableColumnRankPropertyDefinition = {
    view: { label: 'Results Table Column Rank' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'orderedProperties',
            argument: [
                'results-table-column-name',
                'results-table-column-pinned',
                'results-table-column-title',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'results-table-column-rank',
};
const isResultsTableColumnRankProperty = (prop) => {
    return prop.name === exports.resultsTableColumnRankPropertyDefinition.name;
};
exports.isResultsTableColumnRankProperty = isResultsTableColumnRankProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW4tcmFuay5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Jlc3VsdHMtdGFibGUtY29sdW1uLXJhbmsucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx3Q0FBd0MsR0FBRztJQUN0RCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsMkJBQTJCLEVBQUU7SUFDNUMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRTtnQkFDUiwyQkFBMkI7Z0JBQzNCLDZCQUE2QjtnQkFDN0IsNEJBQTRCO2FBQzdCO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsMkJBQTJCO0NBQ0YsQ0FBQTtBQUkxQixNQUFNLGdDQUFnQyxHQUFHLENBQUMsSUFBa0IsRUFBMEMsRUFBRTtJQUM3RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssZ0RBQXdDLENBQUMsSUFBSSxDQUFBO0FBQ3BFLENBQUMsQ0FBQTtBQUZZLFFBQUEsZ0NBQWdDLG9DQUU1QyJ9